export const EUCountries = [
  'BE',
  'BG',
  'DE',
  'DK',
  'EE',
  'FI',
  'FR',
  'GR',
  'IE',
  'IT',
  'HR',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'ES',
  'CZ',
  'HU',
  'CY',
  'AT'
]
